const themes = {
	light: {
		primaryTextColor: '#121212', // main ccolor of text
		secondaryTextColor: '#FFF', // secondary color of text
		additionalTextColor: '#9D9D9D', // secondary color of text
		linkTextColor: '#0C5EFF',
		propertyTextColor: '#6294F5', //

		disabledTextColor: '#979797', // disabled color of text
		dangerTextColor: '#FF2C2C', // danger color of text
		noteTextColor: '#C5C7CD', // note color of text

		primaryBorderColor: '#E4E4E4',
		secondaryBorderColor: '#FFF',
		extraBorderColor: '#979797',
		additionalBorderColor: '#D9D9D9',
		disabledBorderColor: '#C5C7CD',
		primaryBackgroundColor: '#FFF', // main color of bg
    secondaryBackgroundColor: '#1D1F2B',
		disabledColor: '#DFE0EB',
		primaryColor: '#F7F8FC', // main color of bg
		secondaryColor: '#363740', // secondary coplor of bg
		blankColor: '#F1F3F4', // secondary coplor of bg
		backgroundColor: '#FFF',
		additionalBackgroundColor: '#F7F8FA',
		menuItemActive: '#E4EDFF',

		primaryHighlightColor: '#0C5EFF',
		secondaryHighlightColor: '#4047EC',
		invertedCommunityColor: '#4B2FF5',
	
		buttonActionBackgroundColor: '#0C5EFF',
		buttonActionBackgroundHoverColor: '#357AFF',
		buttonActionBackgroundActiveColor: '#095AF5',

		buttonDisabledBackgroundColor: '#E4E4E4',

		buttonDefaultBackgroundColor: 'transparent',
		buttonDefaultBackgroundHoverColor: 'transparent',
		buttonDefaultBackgroundActiveColor: 'transparent',
		buttonDefaultBorderHoverColor: '#121212',
		buttonDefaultBorderActiveColor: '#121212',

		buttonAdditionalBackgroundColor: '#E4EDFF',
		buttonAdditionalBackgroundHoverColor: '#E4EDFF',
		buttonAdditionalTextHoverColor: '#357AFF',
		buttonAdditionalBackgroundActiveColor: '#E4EDFF',
		buttonAdditionalTextActiveColor: '#095AF5',
		buttonDangerTextColor: '#FF5252',

		buttonGradient: 'linear-gradient(to right, #00B2FF 0%, #FA00FF 50%, #00B2FF 100%)',

		tagDefaultBackgroundColor: '#E4E4E4',
		tagDefaultBorderColor: '#9D9D9D',

		tagErrorBackgroundColor: '#FFB4B4',
		tagErrorBorderColor: '#D71E1E',

		tagInfoBackgroundColor: '#FDF0CE',
		tagInfoBorderColor: '#F6B40A',
	
		tagSuccessBackgroundColor: '#D1FAE1',
		tagSuccessBorderColor: '#19E46A',

		tagAdditionalBackgroundColor: '#DEF1FE',
		tagAdditionalBorderColor: '#5CB9FC',


		// grey
		statusBarDefaultBackgroundColor: '#E4E4E4',
		statusBarDefaultBorderColor: '#9D9D9D',

		// yellow
		statusBarInfoBackgroundColor: '#FDF0CE',
		statusBarInfoBorderColor: '#F6B40A',
	
		// green
		statusBarSuccessBackgroundColor: '#D1FAE1',
		statusBarSuccessBorderColor: '#19E46A',




		noteDefaultBackgroundColor: '#E4EDFF',

		noteWarningBackgroundColor: '#FFB4B4',
		noteWarningTextColor: '#D71E1E',
		noteWarningBorderColor: '#D71E1E',

		statusSuccessColor: '#19E46A',
		statusStoppedColor: '#DFE0EB',


	},
	dark: {
		primaryTextColor: 'red',
		secondaryTextColor: '#363740',
		primaryBorderColor: '#DFE0EB',
		secondaryBorderColor: '#FFF',
		primaryColor: '#F7F8FC',
		secondaryColor: '#363740',
		menuItemActive: '#3E4049'
	}
}

export default themes